import { useQuery } from '@tanstack/react-query';

async function getCountriesLookup() {
  const response = await fetch(`/api/v1/rankings/getLookupCountries`);
  const matchData = await response.json();
  return matchData.data;
}

export const useGetCountriesLookup = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountriesLookup(),
    refetchOnWindowFocus: false,
    initialData: {
      results: [],
    },
  });
};

async function getStatesLookup(countryId: string) {
  const response = await fetch(`/api/v1/rankings/getLookupStates?country=${countryId}`);
  const matchData = await response.json();
  return matchData.data;
}

export const useGetStatesLookup = (countryId: string) => {
  return useQuery({
    queryKey: ['states', countryId],
    queryFn: () => getStatesLookup(countryId),
    refetchOnWindowFocus: false,
    enabled: countryId !== '',
    initialData: {
      results: [],
    },
  });
};
